import React from 'react';
import { Typography } from '@vp/react-vp-ui-library';
import { getLocalizedText as t } from '@vp-dst/localization-util';

import { logEvent } from '../utilities/logger';

export function ErrorPage() {
  logEvent('ErrorPageHit');

  return (
    <div
      style={{
        width: '100%',
        height: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography size={2}>:(</Typography>
      <Typography size={3}>{t('generic-error-message')}</Typography>
      <Typography size={4}>
        <a href="/">{t('home')}</a>
      </Typography>
    </div>
  );
}
